import { PureComponent, Component } from 'react'
import _ from 'lodash'
import { HistoryUtil } from '@vzmi/component_ec_nodejs_util/dist/lib'
import { getFeatureToggle } from '@vzmi/component_ec_nodejs_util/dist/lib/FeatureToggleUtil'
import { FormRow, When, CheckboxInputField, HyperLink } from '../../Common/Form'
import { Field, FormValueSelector } from '../../Common/forms'
import SPBaseModule from '../../../lib/SPBaseModule'
import styles from './UpdateListingForm.css'
import { updateListingProposalI13nConf } from '../../../../../conf/i13nConf'

import UiStateContainer from '@vzmi/ec-react-ui-state-container'
import { Button, FormLoader, Disclaimer, ProposalBlock, ProposalSection, Icon, PopoverImg } from '@vzmi/shp_shared_compo'
import SingleLineText from '../Common/ReadOnlyComponents/SingleLineText/SingleLineText'
import { ListingFieldConfig, getApplicantFieldProps } from '../Common/ProposalForm/Shared/FieldConfig'
import { getAttrTransientKey, getSpecAttributeFieldPrefixByLevel, getFormValues, getUpdateListingPreviewPage } from '../Common/ProposalForm/Shared/util'
import { scrollTo, delay } from '../../../../lib/renderUtil'
import {
  promisifySubmitResult,
  scrollToErrorElement,
  createErrorToast,
  FORM_ERROR_MESSAGE
} from '../../../lib/FormHelper'
import errorHelper from '../../../../lib/errorHelper'
import { getLogger } from '../../../../lib/browserLogger'
import {
  UPDATE_LISTING_FORM_KEY,
  PAGE_FLOW,
  PROPOSAL_PHASE_TYPE,
  PROPOSAL_TYPE_NAME,
  WARRANTY_SECTION_NAME,
  COPY_SECTION_NAME
} from '../../../constants/proposalTypes'
import { unbindBeforeunload } from '../Common/BeforeUnload'
import PageFlow from '../Common/PageFlow/PageFlow'
import Tip from '../Common/Tip'
import Editor from '../Common/ProposalForm/Editor/Editor'
import { getSupplierFullNameByUser } from '../../../../lib/proposalHelper'
import ProposalCompletion from '../Common/ProposalCompletion/ProposalCompletion'
import Video from '../Common/ProposalForm/Video/Video'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { loadLocal, removeLocal } from '../../../lib/localStorageHelper'
// import ComplimentariesCollapsePanel
// from './ComplimentariesCollapsePanel/ComplimentariesCollapsePanel'
import ProposalFormHead from '../Common/ProposalFormHead/ProposalFormHead'
import HeadingWithId from '../Common/HeadingWithId/HeadingWithId'
import { ConnectedListingLink } from '../../Common/ListingLink/ListingLink'
import Spec from '../ProductListingBaseForm/Spec'
import ActionLink from '../../Listing/QueryPage/ActionLink/ActionLink'
import Images from './Images/Images'
import ListingModel from '../ProductListingBaseForm/ListingModel'
import Warranty from '../ProductListingBaseForm/Media/Warranty'
import { getContactWindow, WARRANTY_FIELD } from '../Shared'
import { booleanToNum } from '../../../../lib/i13nUtil'
import usePageFlow from '../../BatchProposal/hook/usePageFlow'
import ListingInfo from '../ProductListingBaseForm/ListingInfo'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'
import YPopover from '../../Common/Popover'

const logger = getLogger({ name: UPDATE_LISTING_FORM_KEY })

class UpdateListingFixedTop extends PureComponent {
  renderHeadBtns = () => {
    const {
      pageFlow: { isCurrent },
      handleReturnEdit,
      proposalType
    } = this.props

    const queryParams = HistoryUtil.retrieveQueryParams({ location })
    const proposalId = _.get(queryParams, 'id')
    const listingPreviewUri = getUpdateListingPreviewPage(proposalId, proposalType)

    return (
      <When
        key='confirm'
        value={isCurrent(PAGE_FLOW.CONFIRM)}
        isTrue
      >
        <div
          className={styles.backToEditBtn}
        >
          <HyperLink
            target='_blank'
            href={listingPreviewUri}
            isButton
          >
            <Button
              data-role='listing-preview'
              size='large'
            >
              賣場預覽
            </Button>
          </HyperLink>
          <Button
            data-role='back-to-edit-button'
            size='large'
            buttonType='outline'
            onClick={handleReturnEdit}
          >
            返回編輯
          </Button>
        </div>
      </When>
    )
  }

  renderListingIdField () {
    const {
      proposalType,
      pageFlow: { isCurrent }
    } = this.props

    const proposalTypeName = PROPOSAL_TYPE_NAME[proposalType]

    const headingTitle = isCurrent(PAGE_FLOW.EDIT)
      ? `${proposalTypeName}提案`
      : `修改資訊確認-${proposalTypeName}`

    return (
      <FormValueSelector
        key='listingId'
        selector={
          (select) => ({
            proposalId: select('id'),
            listingId: select('listing.id'),
            swCode: select('listing.swCode')
          })
        }
      >
        {
          values => {
            const {
              swCode,
              proposalId,
              listingId
            } = values

            return (
              <HeadingWithId
                title={headingTitle}
                subtitle={(
                  <>
                    賣場編號：
                    <ConnectedListingLink
                      swCode={swCode}
                      targetListingId={listingId}
                    >
                      {listingId}
                    </ConnectedListingLink>
                    {
                      proposalId && (
                        <div data-role='proposal-id-sub-title'>
                          提案單編號：
                          {proposalId}
                        </div>
                      )
                    }
                  </>
                )}
              />
            )
          }
        }
      </FormValueSelector>
    )
  }

  render () {
    const {
      match: { params: { phase } }
    } = this.props

    switch (phase) {
      case PROPOSAL_PHASE_TYPE.OVERVIEW: {
        return null
      }
      case PROPOSAL_PHASE_TYPE.COMPOSE:
      default: {
        return (
          <div
            key='top'
            className={styles.headTop}
          >
            <div
              key='header'
              className={styles.headHeader}
            >
              {this.renderListingIdField()}
            </div>
            <div
              key='btns'
              className={styles.headBtns}
            >
              {this.renderHeadBtns()}
            </div>
          </div>
        )
      }
    }
  }
}

const UpdateListingHead = ProposalFormHead

const ListingInfoBlock = () => {
  return (
    <FormValueSelector
      selector={select => ({
        listing: select('initiallyFetchedListing')
      })}
    >
      {({ listing = {} }) => (
        <ProposalSection title='賣場資訊'>
          <ProposalBlock>
            <ListingInfo
              listing={listing}
            />
          </ProposalBlock>
        </ProposalSection>
      )}
    </FormValueSelector>
  )
}

const UpdateTarget = props => {
  const {
    setUpdateFormRef,
    array,
    change,
    actions,
    readOnly,
    proposalType,
    proposalTypeName,
    setIsLoading,
    toggleDisableSubmitBtn,
    shipType,
    copy,
    phase,
    currentFlow
  } = props
  // 判斷為修改頁
  const { isEditPage } = usePageFlow(phase, currentFlow)
  let targetCompo = null

  switch (proposalType) {
    case PROPOSAL_TYPE.UPDATE_COPY: {
      const isUpdateWithWarrantyField = 'product.isUpdateWithWarranty'
      return (
        <FormValueSelector
          selector={select => ({
            isUpdateWithWarranty: select(isUpdateWithWarrantyField),
            isOldUpdateCopy: select('product.isOldUpdateCopy')
          })}
        >
          {formValues => {
            const { isUpdateWithWarranty, isOldUpdateCopy } = formValues
            return (
              <>
                <ListingInfoBlock />
                <ProposalSection
                  data-role={`${proposalType}-section`}
                  name={proposalType}
                  title={COPY_SECTION_NAME}
                >
                  <ProposalBlock>
                    <Editor
                      fieldName='listing.copy'
                      shipType={shipType}
                      readOnly={readOnly}
                      copy={copy}
                      isEditPage={isEditPage}
                    />
                  </ProposalBlock>
                </ProposalSection>
                {
                  !isOldUpdateCopy && (
                    <ProposalSection
                      data-role='warranty-section'
                      name={WARRANTY_SECTION_NAME}
                      title={(
                        <Field
                          key='isUpdateWithWarranty'
                          name={isUpdateWithWarrantyField}
                          className={styles.isUpdateWithWarranty}
                          data-role='is-update-with-warranty'
                          component={CheckboxInputField}
                          label='同時修改商品保證'
                          disabled={readOnly}
                        />
                      )}
                    >
                      {isUpdateWithWarranty && (
                        <ProposalBlock>
                          <Warranty
                            fieldName={WARRANTY_FIELD}
                            triggerFieldChange={change}
                            readOnly={readOnly}
                            isNewProposal={false}
                          />
                        </ProposalBlock>
                      )}
                    </ProposalSection>
                  )
                }
              </>
            )
          }}
        </FormValueSelector>
      )
    }

    case PROPOSAL_TYPE.UPDATE_VIDEO: {
      targetCompo = (
        <ProposalBlock>
          <Video
            fieldName='listing.videos[0]'
            readOnly={readOnly}
          />
        </ProposalBlock>
      )
      break
    }

    case PROPOSAL_TYPE.UPDATE_ATTRIBUTE: {
      targetCompo = (
        <Spec
          array={array}
          change={change}
          actions={actions}
          proposalType={proposalType}
        />
      )
      break
    }

    case PROPOSAL_TYPE.UPDATE_IMAGE: {
      targetCompo = (
        <Images
          proposalType={proposalType}
          readOnly={readOnly}
          change={change}
        />
      )
      break
    }

    case PROPOSAL_TYPE.UPDATE_LISTING_MODEL: {
      return (
        <ProposalSection
          data-role={`${proposalType}-section`}
        >
          <ListingModel
            setRef={setUpdateFormRef}
            setIsLoading={setIsLoading}
            readOnly={readOnly}
            actions={actions}
            proposalType={proposalType}
            change={change}
            toggleDisableSubmitBtn={toggleDisableSubmitBtn}
          />
        </ProposalSection>
      )
    }
  }

  return (
    <>
      <ListingInfoBlock />
      <ProposalSection
        data-role={`${proposalType}-section`}
        name={proposalType}
        title={
          proposalType === PROPOSAL_TYPE.UPDATE_IMAGE
            ? (
              <>
                {proposalTypeName}
                <YPopover
                  content={(
                    <PopoverImg
                      url={`${CDN}/supplier/modify_image_description.png`}
                      width={1434}
                      height={698}
                    />
                  )}
                  placement='right'
                >
                  <Icon
                    name='ec-information-fill'
                    size={14}
                    align='baseline'
                    color='#979ba7'
                  />
                </YPopover>
              </>
            )
            : proposalTypeName
        }
      >
        {targetCompo}
      </ProposalSection>
    </>
  )
}

class UpdateListingBody extends Component {
  constructor () {
    super()
    this.state = {
      contactWindow: ''
    }
  }

  componentDidMount () {
    const { user } = this.props
    const contactWindow = getContactWindow(user)
    this.setState({ contactWindow })
  }

  render () {
    const { contactWindow } = this.state
    const {
      setUpdateFormRef,
      toggleDisableSubmitBtn,
      array,
      change,
      actions,
      readOnly,
      proposalType,
      handleComplete,
      proposalTypeName,
      setIsLoading,
      flags,
      pageFlow: { isCurrent, currentFlow },
      match: { params: { phase } },
      reduxFormState
    } = this.props
    const kaFeatureToggle = getFeatureToggle(flags, 'sp_KA')
    const formValues = getFormValues(reduxFormState)
    // 取得當前賣場詳情資料
    const copy = _.get(formValues, 'listing.copy', '')
    return (
      <form
        key='update-listing-body-form'
        autoComplete='off'
        onSubmit={handleComplete}
      >
        <FormValueSelector
          selector={select => ({
            user: select('setting.user'),
            product: select('product'),
            shipType: select('listing.skuDetail.shipType')
          })}
        >
          {
            values => {
              const { user, product, shipType } = values
              const supplierFullName = getSupplierFullNameByUser(user)
              const identity = _.get(user, 'identity', {})

              return (
                <>
                  <ProposalSection
                    name='proposal-background'
                    title='提案背景'
                  >
                    <ProposalBlock>
                      <FormRow
                        key='supplierName'
                        label='提案廠商'
                      >
                        <SingleLineText
                          content={supplierFullName}
                        />
                      </FormRow>
                      <FormRow
                        key='applicant'
                        label='提案人'
                        withInputCountPaddingBottom={!readOnly}
                      >
                        <Field
                          {...ListingFieldConfig.getField('applicant')}
                          className={styles.applicant}
                          {...getApplicantFieldProps(identity, readOnly)}
                        />
                      </FormRow>
                      <FormRow
                        key='subStationId'
                        label='提案站別／對象'
                        contentClassName={styles.centerAlignContent}
                      >
                        <Field
                          name='subStationLabel'
                          data-role='sub-station-label'
                          component={SingleLineText}
                          className={styles.subStationId}
                          simpleValue
                        />
                        {
                          kaFeatureToggle && (
                            <span className={styles.tipLabel}>
                              &nbsp;/&nbsp;
                              {contactWindow}
                            </span>
                          )
                        }
                      </FormRow>
                      <When
                        key='disclaimer'
                        value={isCurrent(PAGE_FLOW.EDIT)}
                        isTrue
                      >
                        <FormRow
                          // 法律聲明
                          key='disclaimer'
                          noLabel
                        >
                          <Disclaimer
                            detailsVisible
                          />
                        </FormRow>
                      </When>
                    </ProposalBlock>
                  </ProposalSection>
                  <UpdateTarget
                    setUpdateFormRef={setUpdateFormRef}
                    array={array}
                    change={change}
                    actions={actions}
                    readOnly={readOnly}
                    proposalType={proposalType}
                    proposalTypeName={proposalTypeName}
                    setIsLoading={setIsLoading}
                    product={product}
                    toggleDisableSubmitBtn={toggleDisableSubmitBtn}
                    shipType={shipType}
                    copy={copy}
                    phase={phase}
                    currentFlow={currentFlow}
                  />
                </>
              )
            }
          }
        </FormValueSelector>
      </form>
    )
  }
}

class UpdateListingFoot extends Component {
  handleBeforeSubmit = async () => {
    const {
      pageFlow: { currentFlow },
      handleComplete,
      handleSendOut,
      getUpdateFormRef
    } = this.props
    let handleClick
    switch (currentFlow) {
      case PAGE_FLOW.EDIT: {
        handleClick = handleComplete
        break
      }
      case PAGE_FLOW.CONFIRM: {
        handleClick = handleSendOut
      }
    }
    // 在送出提案前執行
    let isSubmittable = true
    const beforeFormSubmit = _.get(getUpdateFormRef(), 'beforeFormSubmit')
    if (beforeFormSubmit) {
      isSubmittable = await beforeFormSubmit()
    }
    // 送出新增/修改提案
    isSubmittable && handleClick && handleClick()
  }

  render () {
    const {
      match,
      pageFlow: { currentFlow },
      isDisabledSubmitBtn
    } = this.props

    const phase = _.get(match, 'params.phase', null)
    if (phase === PROPOSAL_PHASE_TYPE.OVERVIEW) { return null }
    let btnContent = ''
    let tipContent = ''
    let dataRole = ''

    switch (currentFlow) {
      case PAGE_FLOW.EDIT: {
        btnContent = '完成提案'
        tipContent = '完成提案後，需確認資訊才會送出審核'
        dataRole = 'complete-proposal-button'
        break
      }
      case PAGE_FLOW.CONFIRM: {
        btnContent = '送出提案'
        tipContent = (
          <>
            送出提案單，即視為已詳閱、了解並同意提案同意書之全部內容，
            <br />
            並應確保所提報及上架之商品符合本平台刊登規範及相關法令、政令之規定；
            <br />
            提案一經送出，內容即不得再行變更。
          </>
        )
        dataRole = 'submit-pending-review-proposal-button'
        break
      }
      default: {
        break
      }
    }

    return (
      <section
        key='cta'
        className={styles.CTA}
      >
        <Button
          size='large'
          color='primary'
          data-role={dataRole}
          onClick={this.handleBeforeSubmit}
          disabled={isDisabledSubmitBtn}
        >
          {btnContent}
        </Button>
        <Tip
          key='info'
          type='info'
          className={styles.CTATip}
        >
          {tipContent}
        </Tip>
      </section>
    )
  }
}

const UpdateListingCompletion = props => {
  const { proposalTypeName, proposalType } = props

  return (
    <FormValueSelector
      selector={select => ({
        id: select('id'),
        listingId: select('listing.id'),
        swCode: select('listing.swCode')
      })}
    >
      {
        values => {
          const {
            id: proposalId,
            listingId,
            swCode
          } = values

          const title = `${proposalTypeName}提案已送出`
          const subTitle = '提案編號：'

          return (
            <ProposalCompletion
              title={title}
              subTitle={subTitle}
              proposalId={proposalId}
              proposalType={proposalType}
              {...props}
            >
              <p className={styles.completionContent}>
                查看賣場:
                <ConnectedListingLink
                  swCode={swCode}
                  targetListingId={listingId}
                >
                  {listingId}
                </ConnectedListingLink>
                ，或關閉此分頁，可返回
                <ActionLink targetURL={'/listing/query'}>
                  查詢頁
                </ActionLink>
                繼續修改其他賣場
              </p>
            </ProposalCompletion>
          )
        }
      }
    </FormValueSelector>

  )
}

/**
 * 修改規格表內容被擋下時需要指定出哪一個欄位出問題
 * api 回應的 index 位置是按照 payload.listing.attributes 給的
 * 但是 payload 實際上不包含非必填且為空值的欄位
 * 因此需要從 api 回應的 index 對應 payload attributes 找出欄位名稱
 * 接著回 redux form 比對 attributes 欄位名稱才能找出真正表單中的 index
 * 最後再把錯誤訊息按照 index 寫入錯誤的規格表欄位
 * @param error 送出表單失敗時回傳的錯誤
 * @param postingProposal 送給 api 的 proposal payload
 * @param reduxFormState 當下整個表單的狀態
 * @returns redux form 規格表欄位錯誤結構
 */
export const getAttributeSyncErrors = (error, postingProposal, reduxFormState) => {
  const errorAttrFieldNames = _.flow(
    // 重構錯誤訊息結構
    errorHelper.extractErrorResult,
    // 從後端提供的規格表欄位找出 payload attributes 的對應路徑
    errorResult => {
      const details = _.get(errorResult, 'detail', [])
      const payloadErrorAttrPaths = _.map(details, detail => {
        const apiErrorAttrPath = _.get(detail, 'invalidValue', '')
        // 預期 api 回應的路徑應為 `Proposal.listing.attributes[120].values[0]`
        // 會被組成 `listing.attributes[120].name`
        const errorAttrPath = `${_.get(apiErrorAttrPath.match(/listing\.attributes\[\d*.\]/), '0')}.name`
        return errorAttrPath
      })
      return payloadErrorAttrPaths
    },
    // 從 payload 路徑找出錯誤的 attributes 名稱
    payloadErrorAttrPaths => _.map(payloadErrorAttrPaths, path => _.get(postingProposal, path)),
    // 清掉空的內容避免實際上取錯都是塞空值
    _.compact
  )(error)
  const { product = {}, subStationId } = _.get(reduxFormState, 'values', {})
  const { catItemId, struDataAttrClusterId } = product
  const transientKey = getAttrTransientKey(subStationId, catItemId, struDataAttrClusterId)
  const transient = _.get(reduxFormState, `values.${transientKey}`, {})
  const specAttributeFieldPrefix = getSpecAttributeFieldPrefixByLevel(transient.hasSpecLevel)
  const attributeNameIndexMap = _.flow(
    // 找出 redux form 儲存 attributes 的地方
    transient => _.get(transient, specAttributeFieldPrefix, []),
    // 將目前表單中全部 attributes 轉換成 { [attrName]: attrIndex } 的對應表
    attrs => _.reduce(attrs, (attrNameIndexMap, attr = {}, index) => {
      attrNameIndexMap[attr.name] = index
      return attrNameIndexMap
    }, {})
  )(transient)
  // 取得後端 error code 對應前端 API_ERROR_MAPPING 取得的錯誤訊息
  const errorMsg = _.get(errorHelper.extractErrorResult(error), 'message')
  // 組出 redux form 顯示錯誤的結構
  const syncErrors = _.reduce(errorAttrFieldNames, (errorFieldMap, errorAttrFieldName) => {
    const errorAttrIndex = attributeNameIndexMap[errorAttrFieldName]
    const errorFieldPath = `${transientKey}.${specAttributeFieldPrefix}[${errorAttrIndex}].values`
    _.set(errorFieldMap, errorFieldPath, errorMsg)
    return errorFieldMap
  }, {})
  return syncErrors
}

export default class UpdateListingForm extends SPBaseModule {
  isFormLoading = () => this.state.isLoading || this.props.submitting

  setIsFormLoading = bool => this.setIsLoading(bool)

  componentDidMount () {
    const {
      proposalType,
      i13nMethods: { sendI13nPageViewByPageKey }
    } = this.props

    sendI13nPageViewByPageKey(`${proposalType}-compose`, updateListingProposalI13nConf)

    /**
     * updateListing form init
     */
    this.initForm()
  }

  setErrorAttributeField = (error) => {
    const { postingProposal, reduxFormState } = this.props
    const syncErrors = getAttributeSyncErrors(error, postingProposal, reduxFormState)
    const isSyncErrorsExist = !_.isEmpty(syncErrors)
    if (isSyncErrorsExist) {
      this.props.updateFormSyncErrors(syncErrors)
      scrollToErrorElement(-20)
      createErrorToast({
        message: FORM_ERROR_MESSAGE,
        error
      })
    }

    return isSyncErrorsExist
  }

  handleInvalidForm = (error) => {
    const { proposalType } = this.props
    if (proposalType === PROPOSAL_TYPE.UPDATE_ATTRIBUTE) {
      const isSetErrorSuccess = this.setErrorAttributeField(error)
      // 萬一 isSetErrorSuccess === false 代表可能不是規格表欄位的錯誤，
      // 這種情況則走預設路線顯示一般 toast 即可
      if (isSetErrorSuccess) {
        return
      }
    }
    // window top offset
    scrollToErrorElement(-20)

    /**
     * 40100003與40100004 在 middleware 中已經有拋出 toast 了，
     * 所以不需要再出現 toast
     */
    const resultErrorCode = _.get(error, 'result[0].code')
    const skipErrorCodes = [40100003, 40100004, 40009182]
    // FIXME: this may need to centralize in somewhere
    if (!_.includes(skipErrorCodes, resultErrorCode)) {
      createErrorToast({
        message: error.message,
        error
      })
    }

    if (resultErrorCode === 40009182) {
      const resultMessage = _.get(error, 'result[0].message', error.message)
      const updateAttributePath = `../${PROPOSAL_TYPE.UPDATE_ATTRIBUTE}/${PROPOSAL_PHASE_TYPE.COMPOSE}`
      createErrorToast({
        message: (
          <>
            {`${resultErrorCode} ${resultMessage}，前往`}
            <HyperLink href={`${updateAttributePath}${location.search}`}>
              修改賣場規格表
            </HyperLink>
            調整
          </>
        ),
        duration: 10
      })
    }
  }

  initForm = async () => {
    const {
      proposalType,
      getFormData,
      match,
      location,
      loadForm,
      getUpdateFormRef
    } = this.props
    this.setIsLoading(true)

    let formData = {}

    const localStorageFormData = loadLocal(UPDATE_LISTING_FORM_KEY)
    let isTargetForm = true
    switch (proposalType) {
      // 在調整賣場屬性項目頁面時因為有額外儲存的狀態，
      // 所以需要判斷賣場編號決定能不能直接從 storage 取得資料
      case PROPOSAL_TYPE.UPDATE_LISTING_MODEL: {
        const storageListingId = `${_.get(localStorageFormData, 'listing.id')}`
        const { listingId } = HistoryUtil.retrieveQueryParams({ location })
        // okta redirect 回來會直接到 compose 頁面，
        // 所以 location 取不到 listingId 即代表是 okta redirect
        const isRedirectFromOkta = _.isUndefined(listingId)
        if (!isRedirectFromOkta && storageListingId !== `${listingId}`) {
          isTargetForm = false
        }
        break
      }
      default:
        break
    }
    if (isTargetForm && localStorageFormData) {
      removeLocal(UPDATE_LISTING_FORM_KEY)
      await delay(0)
      formData = localStorageFormData
    } else {
      formData = await getFormData()
    }

    if (_.isEmpty(formData)) {
      this.handlePageMoveTo(PAGE_FLOW.ERROR)
    } else {
      this.handlePageMoveTo(PAGE_FLOW.EDIT)

      // 改網址，如果是剛 fetch 賣場資料，把網址改成 updateXXXX/compose
      const phase = _.get(match, 'params.phase', null)
      if (!phase) {
        const { location } = this.props
        const { listingId } = HistoryUtil.retrieveQueryParams({ location })
        const pathname = _.get(location, 'pathname', '')
        const pathWithListingId = `${pathname}/${PROPOSAL_PHASE_TYPE.COMPOSE}?listingId=${listingId}`
        window.history.replaceState('', '', pathWithListingId)
      }

      loadForm(formData)
      // 在 compose 頁面 get listing 完成後執行
      // EX: 取得 listing 資料顯示在頁面上
      const afterFormLoaded = _.get(getUpdateFormRef(), 'afterFormLoaded')
      afterFormLoaded && await afterFormLoaded(formData)
      // 待資料載入後將 mustShowFormError 設定成 true 只要欄位驗證失敗就 withFormError 會直接顯示錯誤訊息
      this.props.change('mustShowFormError', true)
    }

    this.setIsLoading(false)
  }

  /** 完成提案 */
  handleComplete = async () => {
    const {
      handleSubmit,
      onFormComplete
    } = this.props

    const triggerFormSubmit = promisifySubmitResult(handleSubmit(onFormComplete))

    try {
      const updateListingSuccess = await triggerFormSubmit()
      if (updateListingSuccess) {
        this.handlePageMoveTo(PAGE_FLOW.CONFIRM)
      }
    } catch (error) {
      logger.debug('handleComplete errors', error)
      this.handleReturnEdit()
      this.handleInvalidForm(error)
      this.setIsLoading(false)
    }
  }

  /** 返回編輯 */
  handleReturnEdit = () => {
    const { location } = this.props
    const { listingId } = HistoryUtil.retrieveQueryParams({ location })
    HistoryUtil.updateHistory({ listingId })
    this.handlePageMoveTo(PAGE_FLOW.EDIT)
  }

  /** 送出提案 */
  handleSendOut = async () => {
    const {
      handleSubmit,
      onFormSubmit
    } = this.props

    const triggerFormSubmit = promisifySubmitResult(handleSubmit(onFormSubmit))

    try {
      const updateListingSuccess = await triggerFormSubmit()
      if (updateListingSuccess) {
        this.handlePageMoveTo(PAGE_FLOW.SUCCESS)
        unbindBeforeunload()
      }
    } catch (error) {
      logger.debug('handleSendOut errors', error)
      this.handleReturnEdit()
      this.handleInvalidForm(error)
    }
  }

  // defines to what to do when page flow changes
  handlePageMoveTo = (pageFlowName, state) => {
    const {
      proposalType,
      i13nMethods: { sendI13nPageViewByPageKey },
      getUpdateFormRef
    } = this.props
    const pageKey = `${proposalType}-${pageFlowName}`
    const convertedI13NConfig = updateListingProposalI13nConf

    switch (pageFlowName) {
      case PAGE_FLOW.EDIT: {
        // when page on edit, set readOnly to false
        scrollTo(0)
        this.props.change('setting.readOnly', false)
        break
      }
      case PAGE_FLOW.CONFIRM: {
        // when page on confirm, set readOnly to true
        scrollTo(0)
        if (proposalType === PROPOSAL_TYPE.UPDATE_LISTING_MODEL) {
          // 判斷賣場屬性調整是否包含新增商品
          const isUpdateListingModelWithNewProduct = _.flow(
            // 抓出 UpdateListingModel 的 props
            () => _.get(getUpdateFormRef(), 'state.sortedTableRows', []),
            // 全部表格列中只有新增商品才會有 attributes 欄位
            sortedTableRows => _.some(sortedTableRows, row => !_.isEmpty(row.attributes))
          )()
          _.set(convertedI13NConfig, `${pageKey}.cat1Id`, booleanToNum(isUpdateListingModelWithNewProduct))
        }
        this.props.change('setting.readOnly', true)
        break
      }
      case PAGE_FLOW.SUCCESS: {
        break
      }
      case PAGE_FLOW.ERROR: {
        break
      }
      default: {
        break
      }
    }

    sendI13nPageViewByPageKey(pageKey, convertedI13NConfig)
    this.pageFlow.moveTo(pageFlowName, state)
  }

  toggleDisableSubmitBtn = (isDisableSubmitBtn) => {
    const nextState = _.isUndefined(isDisableSubmitBtn)
      ? !this.state.isDisabledSubmitBtn
      : isDisableSubmitBtn
    if (this.state.isDisabledSubmitBtn === nextState) {
      return
    }
    this.setState({ isDisabledSubmitBtn: nextState })
  }

  render () {
    const { currentUpdateFormRef } = this.props
    const { isDisabledSubmitBtn } = this.state
    return (
      <div
        className={styles.UpdateListingForm}
        data-role='update-listing-form'
      >
        <UiStateContainer>
          <FormLoader
            isLoading={this.isFormLoading()}
            fixed
          >
            <FormValueSelector
              selector={select => ({
                readOnly: select('setting.readOnly'),
                subStationId: select('subStationId')
              })}
            >
              {
                values => {
                  const { readOnly, subStationId } = values

                  return (
                    <PageFlow
                      ref={r => (this.pageFlow = r)}
                      FixedTopComponent={UpdateListingFixedTop}
                      HeadComponent={UpdateListingHead}
                      FormComponent={UpdateListingBody}
                      FootComponent={UpdateListingFoot}
                      CompletionComponent={UpdateListingCompletion}
                      handleComplete={this.handleComplete}
                      handleReturnEdit={this.handleReturnEdit}
                      handleSendOut={this.handleSendOut}
                      {...this.props}
                      readOnly={readOnly}
                      updateFormRef={currentUpdateFormRef}
                      setIsLoading={this.setIsFormLoading}
                      isDisabledSubmitBtn={isDisabledSubmitBtn}
                      toggleDisableSubmitBtn={this.toggleDisableSubmitBtn}
                      subStationId={subStationId}
                    />
                  )
                }
              }
            </FormValueSelector>
          </FormLoader>
        </UiStateContainer>
      </div>
    )
  }
}
